import React from 'react'
import PropTypes from 'prop-types'
import Select from '../ui/Select/Select'

const optionShape = PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })

const VariableSelect = ({ options, value, onChange }) => (
  <div className="tw:w-64">
    <Select
      options={options}
      placeholder="Choisir une variable"
      value={value}
      isClearable
      onChange={onChange}
    />
  </div>
)

VariableSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  value: optionShape
}

VariableSelect.defaultProps = {
  value: null
}

export default VariableSelect
